import c from "./styles.module.scss";
import Button from "../UI/button";

const PAYMENT_METHOD_LABELS = {
  CARD: "Картой",
  CASH: "Наличными",
};

const PAYMENT_STATUS_LABELS = {
  PENDING: "Ожидает оплаты",
  PAID: "Оплачен",
  FAILED: "Ошибка оплаты",
};

const formatPrice = (price) => {
  if (price === undefined || price === null || price === "") {
    return null;
  }

  return new Intl.NumberFormat("ru-RU", {
    maximumFractionDigits: 0,
  }).format(Number(price));
};

const SuccessOrderInfo = ({ order, orderNumber, paymentMethod, children }) => {
  const formattedPrice = formatPrice(order?.price);
  const paymentMethodLabel =
    PAYMENT_METHOD_LABELS[paymentMethod] || "Будет уточнен менеджером";
  const paymentStatusLabel =
    PAYMENT_STATUS_LABELS[order?.paymentStatus] || "Создан";
  const products = order?.cart_products || order?.cartProducts || [];

  return (
    <div className={c.orderInfo}>
      <div className={c.summary}>
        <div className={c.row}>
          <span>Заказ</span>
          <b>#{order?.id || orderNumber}</b>
        </div>

        {formattedPrice ? (
          <div className={c.row}>
            <span>Сумма</span>
            <b>{formattedPrice} ₸</b>
          </div>
        ) : null}

        <div className={c.row}>
          <span>Оплата</span>
          <b>{paymentMethodLabel}</b>
        </div>

        <div className={c.row}>
          <span>Статус</span>
          <b>{paymentStatusLabel}</b>
        </div>

        {order?.quantity ? (
          <div className={c.row}>
            <span>Товаров</span>
            <b>{order.quantity}</b>
          </div>
        ) : null}

        {order?.discount ? (
          <div className={c.row}>
            <span>Промокод</span>
            <b>-{order.discount}%</b>
          </div>
        ) : null}

        {order?.address ? (
          <div className={c.row}>
            <span>Доставка</span>
            <b>{order.address}</b>
          </div>
        ) : null}
      </div>

      {products.length ? (
        <div className={c.products}>
          <p className={c.productsTitle}>Состав заказа</p>
          <div className={c.productsList}>
            {products.map((item) => {
              const product = item.product || {};
              const itemPrice = formatPrice(item.price);

              return (
                <div className={c.product} key={product.id || product.fullSlug}>
                  <span>{product.name || "Товар"}</span>
                  <b>
                    {item.quantity} x {itemPrice} ₸
                  </b>
                </div>
              );
            })}
          </div>
        </div>
      ) : null}

      <div className={c.disclaimer}>
        Если вы хотите приобрести товар в рассрочку или в кредит — оформление
        происходит через менеджера. Свяжитесь с нами и мы подберём подходящие
        условия.
      </div>

      {children ? (
        <div className={c.paymentBlock}>
          <p className={c.paymentTitle}>Способы оплаты</p>
          <div className={c.actions}>{children}</div>
        </div>
      ) : null}

      <div className={c.catalogAction}>
        <Button text="Вернуться в каталог" link="/products" full={true} />
      </div>
    </div>
  );
};

export default SuccessOrderInfo;
